import React from 'react';

const ThanksCallout = ({ name, children }) => (
  <aside
    className="thanks-callout"
    style={{
      background: 'rgb(0, 96, 129) linear-gradient(135deg, rgb(0, 96, 129), #47924f)',
      color: '#fff',
      textAlign: 'center',
      display: 'block',
      width: 'fit-content',
      borderRadius: '0.5rem',
      padding: '.25rem .5rem',
      margin: '1.5rem auto',
      fontSize: '0.95rem',
      boxShadow: `
        rgba(0, 0, 0, 0.025) 0 0 0 1px,
        rgba(0, 0, 0, 0.05) 0px 1px 0px,
        rgba(0, 0, 0, 0.03) 0px 0px 8px,
        rgba(0, 0, 0, 0.1) 0px 20px 30px`,
    }}
  >
    <strong>
      💙 Thanks {name}
      {!children ? '!' : ''}
    </strong>{' '}
    {children}
    {children ? '!' : ''}
  </aside>
);

export default ThanksCallout;
